import * as React from "react";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import portfolioAction from "../../../../actions/portfolio.action";
import { downloadBlob } from "../../../../utilities/download-blob";

class DownloadPDFButton extends React.Component {
  state = {
    isDownloading: false,
  };

  downloadSummaryPDF = (portfolioIds, householdId) => (e) => {
    this.setState({ isDownloading: true }, () => {
      this.props
        .dispatch(portfolioAction.getPortfolioPDF(portfolioIds, householdId, 0))
        .then(async (response) => {
          if (response) {
            await downloadBlob(response, `portfolio-summary.pdf`);
            this.setState({ isDownloading: false });
          }
        });
    });
  };

  render() {
    const { portfolioIds, householdId, labelText } = this.props;
    const { isDownloading } = this.state;
    const style = {
      fontSize: 12,
      textTransform: "none",
      minWidth: 100,
    };

    return (
      <Button
        style={style}
        onClick={this.downloadSummaryPDF(portfolioIds, householdId)}
        variant="outlined"
        color="primary"
        size={"small"}
      >
        {isDownloading ? <CircularProgress size={16} /> : (labelText || "Download PDF")}
      </Button>
    );
  }
}

export default connect(null, null)(DownloadPDFButton);



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/components/DownloadPDFButton/index.jsx